var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 14.2819V17.7181C8.5 18.1638 8.45359 18.3255 8.36643 18.4884C8.27928 18.6514 8.15139 18.7793 7.98842 18.8664C7.82546 18.9536 7.66382 19 7.21806 19H5.5C3.84315 19 2.5 17.6569 2.5 16C2.5 14.6938 3.33481 13.5825 4.5 13.1707V11C4.5 6.58172 8.08172 3 12.5 3C16.9183 3 20.5 6.58172 20.5 11V13.1707C21.6652 13.5825 22.5 14.6938 22.5 16C22.5 17.6569 21.1569 19 19.5 19H17.7819C17.3362 19 17.1745 18.9536 17.0116 18.8664C16.8486 18.7793 16.7207 18.6514 16.6336 18.4884C16.5464 18.3255 16.5 18.1638 16.5 17.7181V14.2819C16.5 13.8362 16.5464 13.6745 16.6336 13.5116C16.7207 13.3486 16.8486 13.2207 17.0116 13.1336C17.1745 13.0464 17.3362 13 17.7819 13H18.5V11C18.5 7.68629 15.8137 5 12.5 5C9.18629 5 6.5 7.68629 6.5 11V13H7.21806C7.66382 13 7.82546 13.0464 7.98842 13.1336C8.15139 13.2207 8.27928 13.3486 8.36643 13.5116C8.45359 13.6745 8.5 13.8362 8.5 14.2819Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.bd719496a7527ab5835236dbce9163ea.svg";
export { ForwardRef as ReactComponent };